import { render, staticRenderFns } from "./Progressnotes.vue?vue&type=template&id=454e3d38&"
import script from "./Progressnotes.vue?vue&type=script&lang=js&"
export * from "./Progressnotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports